module.exports = __webpack_public_path__ + "static/flags/RO-0550b66ab3b05ed01ab03e86b7bc8958.gif";